<template>
	<v-col cols="12" sm="6" md="3" lg="3">
		<v-layout align-center justify-space-between column fill-height>
			<v-flex grow class="mb-5">
				<v-card class="fill-height bubble">
					<v-card-text class="text-center fill-height">
						{{ summary }}
					</v-card-text>
				</v-card>	
			</v-flex>

			<v-flex shrink class="mb-3">
				<v-avatar color="primary" size="48">
					<span class="white--text headline">{{ name.charAt(0) }}</span>
			    </v-avatar>
			</v-flex>
			<v-flex shrink>
				<span class="grey--text">{{ name }}</span>
			</v-flex>
		</v-layout>	
	</v-col>
</template>

<script>
export default {
	props: [
		'avatar_url',
		'name',
		'summary',
		'created_at',
		'updated_at',
	]
}
</script>